import Filters from "components/Filters";
import withCollapse from "hocs/withCollapse";
import { useTableConstructor } from "layout/TableConstructor/context/tableConstructorContext";
import { Identifiable, IFilterProps } from "../../types";

const CollapsedFilters = withCollapse(Filters);

const TableFilters = <T extends Identifiable, AvailableFilters extends object, OrderField extends string>({
  form,
  ...props
}: IFilterProps<AvailableFilters>) => {
  const { visibleFilterConfig } = useTableConstructor<T, AvailableFilters, OrderField>();

  return (
    <CollapsedFilters
      // @ts-expect-error типизировать не получается, ошибок быть не должно
      form={form}
      filters={visibleFilterConfig}
      hiddenText='показать фильтры'
      expandedText='скрыть фильтры'
      {...props}
    />
  );
};

export default TableFilters;
